import { SeoPageMetaContent, SeoPlaceholderValues } from '@pflegia/types/common/seo-page-meta/seo-page-meta';
import { fillSeoPageMeta, normalizeSeoPagePath } from '@pflegia/util/common/seo-page-meta';

import { SeoPageMetaProp } from '@shared/graphql/operations/seo-page-meta';

interface GetActiveJobBoardSeoMetaParams {
  seoMeta?: SeoPageMetaProp | null;
  listingPath: string;
  hasMultipleFilters: boolean;
  values: SeoPlaceholderValues;
}

export const getActiveJobBoardSeoMeta = ({
  seoMeta,
  listingPath,
  hasMultipleFilters,
  values,
}: GetActiveJobBoardSeoMetaParams): SeoPageMetaContent | null => {
  if (!seoMeta || hasMultipleFilters || normalizeSeoPagePath(listingPath) !== seoMeta.path) return null;

  return fillSeoPageMeta(seoMeta, values);
};
